module.exports = __webpack_public_path__ + "img/onboarding_notification_en.b7f3d35b.png";